import React from 'react';
import { useHistory, useRouteMatch } from 'react-router-dom';
import { useSnackbar } from 'notistack';
import { Formik } from 'formik';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import makeStyles from '@material-ui/core/styles/makeStyles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';

import discountCodesClient from '../../../../clients/discount-codes';
import TextInput from '../../../../web-app-components/components/TextInput';

const useStyles = makeStyles((theme) => ({
  header: {
    marginBottom: theme.spacing(2),
  },
  form: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    maxWidth: 400,
  },
  submit: {
    marginTop: theme.spacing(1),
    alignSelf: 'flex-start',
  },
  helperNote: {
    marginTop: theme.spacing(-1),
    marginBottom: theme.spacing(1),
    color: theme.palette.text.secondary,
    fontSize: '0.75rem',
    fontWeight: 400,
  },
}));

const validate = (values) => {
  const errors = {};
  if (values.DiscountPercent != null) {
    const p = Number(values.DiscountPercent);
    if (Number.isNaN(p) || p < 1 || p > 100) {
      errors.DiscountPercent = 'Nuolaida turi būti nuo 1 iki 100';
    }
  }
  if (values.UsageLimit != null) {
    const n = Number(values.UsageLimit);
    if (Number.isNaN(n) || n < 1 || !Number.isInteger(n)) {
      errors.UsageLimit =
        'Panaudojimų limitas turi būti sveikasis skaičius ≥ 1';
    }
  }
  return errors;
};

const NewDiscount = () => {
  const classes = useStyles();
  const history = useHistory();
  const { path } = useRouteMatch();
  const { enqueueSnackbar } = useSnackbar();

  const handleSubmit = async (values) => {
    try {
      const payload = {
        Code: (values.Code || '').trim() || undefined,
        DiscountPercent: Number(values.DiscountPercent),
        Target: 'routes',
        UsageLimit: Number(values.UsageLimit),
        Active: values.Active !== false,
      };
      const result = await discountCodesClient.create(payload);
      const id =
        result?.documentId ??
        result?.id ??
        result?.data?.documentId ??
        result?.data?.id;
      enqueueSnackbar('Nuolaidos kodas sukurtas', { variant: 'success' });
      history.push(id ? path.replace('/new', `/${id}`) : path);
    } catch (error) {
      const msg =
        error?.response?.data?.error?.message ||
        error?.message ||
        'Nepavyko sukurti';
      enqueueSnackbar(msg, { variant: 'error' });
    }
  };

  return (
    <div>
      <Typography variant="h5" className={classes.header}>
        Naujas nuolaidos kodas
      </Typography>
      <Formik
        initialValues={{
          Code: '',
          DiscountPercent: 10,
          UsageLimit: 100,
          Active: true,
        }}
        validate={validate}
        onSubmit={handleSubmit}
      >
        {({
          values,
          errors,
          touched,
          handleChange,
          handleBlur,
          handleSubmit: submit,
          isSubmitting,
        }) => (
          <form onSubmit={submit} className={classes.form}>
            <TextInput
              name="Code"
              label="Kodas"
              value={values.Code}
              onChange={handleChange}
              onBlur={handleBlur}
              error={touched.Code && Boolean(errors.Code)}
              helperText={touched.Code && errors.Code}
              fullWidth
            />
            <Typography className={classes.helperNote}>
              Palikite tuščią - bus sugeneruotas automatiškai
            </Typography>
            <TextInput
              name="DiscountPercent"
              label="Nuolaida (%)"
              type="number"
              inputProps={{ min: 1, max: 100 }}
              value={values.DiscountPercent}
              onChange={handleChange}
              onBlur={handleBlur}
              error={touched.DiscountPercent && Boolean(errors.DiscountPercent)}
              helperText={touched.DiscountPercent && errors.DiscountPercent}
              fullWidth
            />
            <TextInput
              name="UsageLimit"
              label="Panaudojimų limitas"
              type="number"
              inputProps={{ min: 1, step: 1 }}
              value={values.UsageLimit}
              onChange={handleChange}
              onBlur={handleBlur}
              error={touched.UsageLimit && Boolean(errors.UsageLimit)}
              helperText={touched.UsageLimit && errors.UsageLimit}
              fullWidth
            />
            <FormControlLabel
              control={
                <Checkbox
                  name="Active"
                  checked={values.Active}
                  onChange={handleChange}
                  color="primary"
                />
              }
              label="Aktyvus"
            />
            <Box className={classes.submit}>
              <Button
                type="submit"
                variant="contained"
                color="primary"
                disabled={isSubmitting}
              >
                {isSubmitting ? 'Kuriama...' : 'Sukurti'}
              </Button>
            </Box>
          </form>
        )}
      </Formik>
    </div>
  );
};

export default NewDiscount;
